export const API_PATHS = {
  USER_MANAGEMENT: '/api/v1/usermanagement/',
};

export const AUTH_CONSTANTS = {
  CUSTOM_TOKEN_CLAIM: 'https://eleos.auth.token',
};

export const APP_CONSTANTS = {
  ADMIN_APP_PATH: 'admin',
};

export const ROLES = {
  ELEOS_ADMINPORTAL_ADMIN: 'eleos_adminportal_admin',
};

export const PROFESSION_IDS = {
  CASE_MANAGER: 'CM',
  LCSW: 'LCSW',
  COUNSELOR: 'COUNSELOR',
  PEER_SPECIALIST: 'PEER_SPECIALIST',
  PSYCHIATRIST: 'PSYCHIATRIST',
  HOSPICE_REGISTERED_NURSE: 'HOSPICE_REGISTERED_NURSE',
  OCCUPATIONAL_THERAPIST: 'OCCUPATIONAL_THERAPIST',
  CLINICAL_PSYCHOLOGIST: 'CLINICAL_PSYCHOLOGIST',
  LMHC: 'LMHC',
  LCPC: 'LCPC',
  MFT: 'MFT',
  RN: 'RN',
  LPC: 'LPC',
} as const;

export const ALLOWED_PROFESSION_IDS = Object.values(PROFESSION_IDS);
export const DEFAULT_PROFESSION_ID = PROFESSION_IDS.CASE_MANAGER;

